import { Component, OnInit, OnDestroy, Output, EventEmitter, ViewEncapsulation } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal/modal-options.class';
import { Store } from '@ngrx/store';
import { ToasterService } from 'angular2-toaster';
import swal from 'sweetalert2';
import * as _ from 'lodash';

import * as fromCommonStore from '../../../store';
import * as fromRootStore from '../../../reducers';

import { PovConfigService, PocService } from '../../../services/index';

@Component({
    selector: 'add-edit-pov-config-window',
    templateUrl: './addEditPovConfig.component.html',
    encapsulation: ViewEncapsulation.None,
    styles: [`
        .pvc-wrap      { background:#fff; display:flex; flex-direction:column; max-height:90vh; border-radius:6px; overflow:hidden; }
        .pvc-header    { background:#059669; color:#fff; padding:12px 18px; display:flex; justify-content:space-between; align-items:center; font-size:13px; font-weight:700; flex-shrink:0; }
        .pvc-close     { background:rgba(255,255,255,0.2); border:none; color:#fff; border-radius:4px; padding:3px 9px; cursor:pointer; font-size:16px; line-height:1; }
        .pvc-body      { padding:18px 20px; overflow-y:auto; flex:1; }
        .pvc-strip     { display:flex; gap:16px; flex-wrap:wrap; background:#f0fdf4; border:1px solid #a7f3d0; border-radius:6px; padding:10px 14px; margin-bottom:14px; }
        .pvc-si        { display:flex; flex-direction:column; gap:2px; }
        .pvc-si-lbl    { font-size:10px; color:#6b7280; text-transform:uppercase; letter-spacing:0.5px; font-weight:700; }
        .pvc-si-val    { font-size:12px; color:#1f2937; font-weight:600; }
        .pvc-sec-lbl   { font-size:10px; font-weight:700; text-transform:uppercase; letter-spacing:0.6px; margin-bottom:6px; background:transparent !important; padding:0; }
        .pvc-box       { border-radius:6px; padding:10px 12px; margin-bottom:12px; }
        .pvc-box-g     { border:1.5px solid #a7f3d0; background:#f0fdf4; }
        .pvc-box-b     { border:1.5px solid #bfdbfe; background:#eff6ff; }
        .pvc-box-lbl   { font-size:10px; font-weight:700; text-transform:uppercase; letter-spacing:0.5px; margin-bottom:8px; }
        .pvc-box-g .pvc-box-lbl  { color:#065f46; }
        .pvc-box-b .pvc-box-lbl  { color:#1e40af; }
        .pvc-chips     { display:flex; flex-wrap:wrap; gap:6px; }
        .pvc-chip      { display:inline-block; padding:3px 10px; border-radius:12px; font-size:11px; font-weight:600; cursor:pointer; border:1.5px solid #e5e7eb; background:#f3f4f6; color:#6b7280; transition:all 0.15s; user-select:none; }
        .pvc-chip.on-g { background:#d1fae5 !important; color:#065f46 !important; border-color:#6ee7b7 !important; }
        .pvc-chip.on-b { background:#dbeafe !important; color:#1e40af !important; border-color:#93c5fd !important; }
        .pvc-hint      { font-size:11px; color:#6b7280; margin-top:7px; }
        .pvc-hint-key  { background:#e5e7eb; padding:1px 6px; border-radius:3px; font-family:monospace; font-size:12px; color:#374151; }
        .pvc-row       { display:flex; gap:14px; align-items:flex-start; margin-bottom:12px; }
        .pvc-pov-col   { flex:1; }
        .pvc-stat-col  { width:140px; }
        .pvc-stat-lbl  { font-size:10px; font-weight:700; color:#6b7280; text-transform:uppercase; letter-spacing:0.6px; margin-bottom:5px; }
        .pvc-footer    { border-top:1px solid #e5e7eb; padding:12px 20px; display:flex; justify-content:flex-end; gap:10px; background:#f9fafb; flex-shrink:0; }
        .pvc-btn-c     { background:#fff; border:1px solid #d1d5db; border-radius:4px; padding:6px 18px; font-size:12px; font-weight:600; color:#374151; cursor:pointer; }
        .pvc-btn-s     { background:#059669; border:none; border-radius:4px; padding:6px 20px; font-size:12px; font-weight:700; color:#fff; cursor:pointer; }
        .pvc-btn-s:disabled { opacity:0.6; cursor:not-allowed; }
        .pvc-pov-chip  { display:inline-block; padding:2px 8px; border-radius:10px; font-size:11px; font-weight:600; background:#d1fae5; color:#065f46; }
    `]
})
export class AddEditPovConfigComponent implements OnInit, OnDestroy {
    public title: string;

    private _rowdata: any = {};
    get rowdata() { return this._rowdata; }
    get isViewMode(): boolean { return this._rowdata && this._rowdata['mode'] === 'View'; }

    set rowdata(val: any) {
        this._rowdata = val;
        if (val && (val['mode'] === 'Edit' || val['mode'] === 'View')) {
            this.selectedPovs          = (val['pov_name_arr'] || []).slice();
            this.selectedPocIds        = (val['poc_ids_arr']  || []).map(Number);
            this.selectedOutStatusIds  = (val['out_status_fol_ids_arr'] || []).map(Number);
            this.statusValue           = val['status'] || 'Active';
        } else {
            this.selectedPovs         = [];
            this.selectedPocIds       = [];
            this.selectedOutStatusIds = [];
            this.statusValue          = 'Active';
        }
    }

    isLoading = false;
    @Output() saveEvent = new EventEmitter();

    povList = ['Testing', 'Trial', 'Therapy', 'Programing', 'Re-Programing', 'Re-Check up', 'Re-Trial', 'Fitting', 'Mould', 'OCT', 'Assessment', 'Cleaning'];
    pocList: any[]       = [];
    outStatusList: any[] = [];

    selectedPovs: string[]         = [];
    selectedPocIds: number[]       = [];
    selectedOutStatusIds: number[] = [];
    statusValue = 'Active';

    subscribeFolStatus;

    get storedAs(): string {
        if (!this.selectedPovs.length) { return ''; }
        return [...this.selectedPovs].sort().join(',');
    }

    constructor(
        public store: Store<fromRootStore.State>,
        public bsModalRef: BsModalRef,
        public toasterService: ToasterService,
        private povConfigService: PovConfigService,
        private pocService: PocService
    ) {}

    ngOnInit(): void {
        this.pocService.getPocList({ start: '0', limit: '200', orderColumn: 'name', orderDir: 'asc', filter: '' })
            .then((res: any) => { if (res && res.data) { this.pocList = res.data; } });

        this.subscribeFolStatus = this.store.select(fromCommonStore.getAllFollowUpStatus).subscribe((res: any) => {
            if (!_.isEmpty(res.data)) {
                this.outStatusList = _.filter(res.data, (o) => o['is_clientout'] === 'Yes');
            }
        });
    }

    ngOnDestroy() {
        if (this.subscribeFolStatus) { this.subscribeFolStatus.unsubscribe(); }
    }

    togglePov(opt: string): void {
        const i = this.selectedPovs.indexOf(opt);
        if (i === -1) { this.selectedPovs.push(opt); } else { this.selectedPovs.splice(i, 1); }
    }
    isPovSelected(opt: string): boolean { return this.selectedPovs.indexOf(opt) !== -1; }

    togglePoc(id: any): void {
        const n = Number(id), i = this.selectedPocIds.indexOf(n);
        if (i === -1) { this.selectedPocIds.push(n); } else { this.selectedPocIds.splice(i, 1); }
    }
    isPocSelected(id: any): boolean { return this.selectedPocIds.indexOf(Number(id)) !== -1; }

    toggleOutStatus(id: any): void {
        const n = Number(id), i = this.selectedOutStatusIds.indexOf(n);
        if (i === -1) { this.selectedOutStatusIds.push(n); } else { this.selectedOutStatusIds.splice(i, 1); }
    }
    isOutStatusSelected(id: any): boolean { return this.selectedOutStatusIds.indexOf(Number(id)) !== -1; }

    onSave(): void {
        if (!this.selectedPovs.length) {
            this.toasterService.pop({ type: 'warning', title: 'WARNING', body: 'Please select at least one POV' });
            return;
        }
        let data: any = {
            pov_name:            this.storedAs,
            poc_ids:             this.selectedPocIds.join(','),
            out_status_fol_ids:  this.selectedOutStatusIds.join(','),
            status:              this.statusValue
        };
        if (this._rowdata && this._rowdata['mode'] === 'Edit' && this._rowdata['id']) {
            data['id'] = this._rowdata['id'];
        }
        this.isLoading = true;
        this.povConfigService.addUpdate(data).then((res: any) => {
            this.isLoading = false;
            if (res.success) { swal('SUCCESS', res.message, 'success'); this.saveEvent.emit(); this.bsModalRef.hide(); }
            else             { swal('ERROR',   res.message, 'error'); }
        });
    }
}



// WEBPACK FOOTER //
// /Applications/MAMP/htdocs/crm-soundsgood/src/app/components/master/povConfig/addEditPovConfig.component.ts